import React, { FC, useEffect, useState } from 'react';

interface ChapterProps {
  image: any;
  title: string;
  subtitle: string;
  description: string;
  ctaUrl: string;
  alt: string;
}

export const Chapter: FC<ChapterProps> = ({
  image,
  title,
  subtitle,
  description,
  ctaUrl,
  alt,
}) => {
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {
    const img = new Image();
    img.src = image;
    img.onload = () => setIsLoaded(true);
    return () => {
      img.onload = null;
    };
  }, [image]);

  return (
    <div
      className="fpv-ace-chapter-container"
      style={{
        height: '80vh',
        width: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        transition: 'opacity 0.3s ease',
      }}
    >
      <div className="fpv-container">
        <div className="fpv-img-container">
          <div className="fpv-red-effect" style={{ filter: 'blur(54px)' }} />
          {isLoaded && (
            <img
              src={image}
              className="fpv-img"
              alt={alt}
              style={{ maxHeight: '60vh', width: 'auto' }}
            />
          )}
        </div>
        <div className="fpv-text-container">
          <div className="fpv-text-sub-container">
            <div className="fpv-subtitle">{subtitle}</div>
            <div className="fpv-title">{title}</div>
          </div>
          <div className="fpv-description">{description}</div>
          <div className="dreamX__discover--button">
            <a
              href={ctaUrl}
              target="_blank"
              rel="noopener noreferrer"
              className="btn btn--primary btn--med"
              onMouseDown={e => e.preventDefault()}
            >
              Buy Now
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};
